import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const API_CONTEXT_PATH = API_BASE_RELATIVE_PATH.replace("/ReactApp", "");
const LLM_FEATURE_CONFIG_KEY = ["llmFeatureConfig"];
const EMPTY_LLM_FEATURE_CONFIG = [];

const getLlmFeatureConfigs = async () => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BASE_PATH}${API_CONTEXT_PATH}/llm-feature-config/${user.companyid}`,
  );

  return typeof response.data === "string" ? JSON.parse(response.data) : response.data;
};

export const useGetLlmFeatureConfigQuery = (enabled = true) => {
  return useQuery({
    queryKey: LLM_FEATURE_CONFIG_KEY,
    queryFn: getLlmFeatureConfigs,
    enabled,
    select: (data) => data ?? EMPTY_LLM_FEATURE_CONFIG,
  });
};

const updateLlmFeatureConfig = async ({ id, isOpenaiEnabled, isGeminiEnabled }) => {
  const user = getUserDetails();
  const params = new URLSearchParams({
    id,
    isOpenaiEnabled,
    isGeminiEnabled,
  }).toString();
  return axios.post(
    `${API_BASE_PATH}${API_CONTEXT_PATH}/llm-feature-config/update/${user.companyid}?${params}`,
    null,
  );
};

export const useUpdateLlmFeatureConfigMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateLlmFeatureConfig,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: LLM_FEATURE_CONFIG_KEY }),
  });
};
